/**
 * EventHero — title band over the cover image.
 *
 * The status chip carries `data-arcee-status` and no text of its own. That is
 * not an oversight: the chip's wording and its dot colour are written in
 * eventDetail.css, one rule per status, and the attribute is what selects
 * between them. Putting the words here instead would leave the stylesheet's
 * `::after` rules fighting with a React child for the same box.
 */

import React from 'react';
import EventShareMenu from './EventShareMenu';

export default function EventHero({
  status, title, coverImageUrl, location, startDatetime, timeZoneLabel,
  // The event's own public link. Absent — a page rendered without one, or a
  // record with no id — and the share control simply is not drawn.
  shareUrl = null,
  // The invitation the link travels with, built by the template from the
  // event's activities. Absent and the menu falls back to the title.
  shareMessage = '',
}) {
  return (
    /* The hero's markup below is exactly what it was. The wrapper is only a
       positioning context the share menu can open out of: .evb-hero crops its
       cover with overflow:hidden and would cut the menu off at the image
       edge. See the share block in eventDetail.css. */
    <div className="evb-hero-wrap">
    <header className="evb-hero">
      <div className="evb-hero__art" />
      {/* The gradient behind it is the fallback, so a missing cover is a
          deliberate look rather than an empty frame. */}
      {coverImageUrl && (
        <img className="evb-hero__img" src={coverImageUrl} alt={title} />
      )}
      <div className="evb-hero__scrim" />
      <div className="evb-hero__in">
        <span className="evb-chip" data-arcee-status={status}><i /></span>
        <h1 className="evb-hero__t">{title}</h1>
        {/* The zone sits with the time, never on a line of its own: "5:25 am"
            with the "IST" orphaned below reads as two facts rather than one.
            The whole clause wraps together or not at all. */}
        <p className="evb-hero__m">
          {location} &nbsp;&middot;&nbsp;
          <span className="evb-hero__when">
            {startDatetime}
            {timeZoneLabel ? <span className="evb-hero__tz">{timeZoneLabel}</span> : null}
          </span>
        </p>
      </div>
    </header>

      {/* A SIBLING of the hero, not a child — see the wrapper's comment. */}
      <EventShareMenu url={shareUrl} title={title} message={shareMessage} />
    </div>
  );
}
